import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import { NavList } from 'transfix-ui/components/NavList/NavList'
import NavListItem from 'transfix-ui/components/NavListItem/NavListItem'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useUserDetails } from 'utils/hooks'
import { LandingPageContent } from './LandingPageContent'

export enum EDI_TOOLS_ROUTES {
  MAPPER_FILES = '/mapper-files',
  SHIPPER_CONFIG = '/shipper-config',
  SELF_SERVE_INBOUND = '/self-service/inbound',
  SELF_SERVE_OUTBOUND = '/self-service/outbound',
  AS2_CONNECTION_CONFIGS = '/connection-configs/as2',
  INBOUND_CONNECTION_CONFIGS = '/connection-configs/inbound',
  OUTBOUND_CONNECTION_CONFIGS = '/connection-configs/outbound',
  SELF_SERVE_INBOUND_DOCUMENTATION = '/inbound-parser-documentation',
  RAW_EDI_FILES_DETAILS = '/mapper-files/:direction/:id/details',
  FILE_ROUTING_CONFIGS = '/tms-configs/file-routing-configs',
  SHIPPER_CONTACTS = '/shipper-contacts',
}

const userLandingPageStyles = makeStyles(theme => ({
  body: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: '1fr 8fr',
    gap: theme.spacing(3),
    margin: theme.spacing(0, 3),
    paddingTop: theme.spacing(2),
    '& > nav': {
      zIndex: 0,
    },
  },
  navHeader: {
    '& div': {
      color: brandColors.coolGray7,
    },
  },
  navItem: {
    '& div': {
      whiteSpace: 'break-spaces',
      margin: theme.spacing(0, 0, 0, 1),
    },
  },
}))

export const LandingPage = () => {
  const classes = userLandingPageStyles()
  const match = useRouteMatch()

  const { userPermissions } = useUserDetails()
  const {
    canAccessAs2ConnectionConfigs,
    canAccessEdiMapperConnectionConfigs,
    canAccessSelfServeInboundParser,
    canAccessSelfServeOutboundBuilder,
  } = userPermissions || {}
  const userHasEdiIntegrationSpecialistRole =
    canAccessAs2ConnectionConfigs &&
    canAccessEdiMapperConnectionConfigs &&
    canAccessSelfServeInboundParser &&
    canAccessSelfServeOutboundBuilder

  return (
    <div className={classes.body}>
      <NavList variant='dark'>
        <div className={classes.navHeader}>
          <NavListItem text='EDI Integrations' disabled />
        </div>
        <div className={classes.navItem}>
          <NavListItem
            text='EDI Files Lookup'
            location={EDI_TOOLS_ROUTES.MAPPER_FILES}
            selected={match?.url === EDI_TOOLS_ROUTES.MAPPER_FILES}
          />
        </div>
        <div className={classes.navItem}>
          <NavListItem
            text='Shipper Configuration'
            location={EDI_TOOLS_ROUTES.SHIPPER_CONFIG}
            selected={match?.url === EDI_TOOLS_ROUTES.SHIPPER_CONFIG}
          />
        </div>
        {userHasEdiIntegrationSpecialistRole && (
          <div>
            <div className={classes.navHeader}>
              <NavListItem text='Data Transformation' disabled />
            </div>
            <div className={classes.navItem}>
              <NavListItem
                text='Self Serve Parser'
                location={EDI_TOOLS_ROUTES.SELF_SERVE_INBOUND}
                selected={match?.url === EDI_TOOLS_ROUTES.SELF_SERVE_INBOUND}
              />
            </div>
            <div className={classes.navItem}>
              <NavListItem
                text='Self Serve Builder'
                location={EDI_TOOLS_ROUTES.SELF_SERVE_OUTBOUND}
                selected={match?.url === EDI_TOOLS_ROUTES.SELF_SERVE_OUTBOUND}
              />
            </div>
            <div className={classes.navHeader}>
              <NavListItem text='Connection Configs' disabled />
            </div>
            <div className={classes.navItem}>
              <NavListItem
                text='AS2'
                location={EDI_TOOLS_ROUTES.AS2_CONNECTION_CONFIGS}
                selected={match?.url === EDI_TOOLS_ROUTES.AS2_CONNECTION_CONFIGS}
              />
            </div>
            <div className={classes.navItem}>
              <NavListItem
                text='Inbound'
                location={EDI_TOOLS_ROUTES.INBOUND_CONNECTION_CONFIGS}
                selected={match?.url === EDI_TOOLS_ROUTES.INBOUND_CONNECTION_CONFIGS}
              />
            </div>
            <div className={classes.navItem}>
              <NavListItem
                text='Outbound'
                location={EDI_TOOLS_ROUTES.OUTBOUND_CONNECTION_CONFIGS}
                selected={match?.url === EDI_TOOLS_ROUTES.OUTBOUND_CONNECTION_CONFIGS}
              />
            </div>
            <div className={classes.navHeader}>
              <NavListItem text='TMS Configs' disabled />
            </div>
            <div className={classes.navItem}>
              <NavListItem
                text='File Routing'
                location={EDI_TOOLS_ROUTES.FILE_ROUTING_CONFIGS}
                selected={match?.url === EDI_TOOLS_ROUTES.FILE_ROUTING_CONFIGS}
              />
            </div>
          </div>
        )}
      </NavList>
      <LandingPageContent />
    </div>
  )
}
